import { Navigate } from "react-router";
import { ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";

export default function PrivateRoute({ children }: { children: ReactNode }) {
  const { token, user } = useAuth();

  if (!token || !user) {
    return <Navigate to="/signin" replace />;
  }

  return children;
}
